<p>add-manually works!</p>
